import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { Tabs } from 'flowbite';

document.addEventListener('DOMContentLoaded', function ()
{
    const navbar = document.getElementById('navbar-attribute');
    const hero = document.getElementById('hero');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            entries.forEach(entry => {
                navbar.classList.toggle('is-sticky', !entry.isIntersecting);
            });
        });
    }, {
        root: null,
        threshold: 0
    });

    observer.observe(hero);

    const swiperHero = new Swiper('.swiper-hero', {
        loop: true,
        autoplay: true,
        speed: 1500,
        pagination: {
            el: ".swiper-pagination-hero",
        },
    });

    const swiperAtributos = new Swiper('.swiper-atributos', {
        loop: true,
        /*        autoplay: true,
                speed: 1500,*/
        navigation: {
            nextEl: ".swiper-button-next-atributos",
            prevEl: ".swiper-button-prev-atributos",
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3.5,
                spaceBetween: 30,
            },
            1920: {
                slidesPerView: 3.6,
                spaceBetween: 35,
            },
        }
    });

    const swiperGaleria = new Swiper('.swiper-galeria', {
        loop: true,
        /*        autoplay: true,
                speed: 1500,*/
        pagination: {
            el: ".swiper-pagination-galeria",
            // dynamicBullets: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: true
            },
            768: {
                slidesPerView: 1.6,
                spaceBetween: 50,
            },
            1024: {
                slidesPerView: 2.4,
                spaceBetween: 45,
            },
            1920: {
                slidesPerView: 2.5,
                spaceBetween: 50,
            },
        }
    });

    const swiperContainers = document.querySelectorAll('.swiper-plantas');

    swiperContainers.forEach(container => {
        const swiperId = container.id.replace('swiper-', '');

        new Swiper(`#${container.id}`, {
            loop: true,
            navigation: {
                nextEl: `.swiper-button-next-${swiperId}`,
                prevEl: `.swiper-button-prev-${swiperId}`,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
            }
        });
    });
    const tabsElement = document.getElementById('tabs-plantas');
    const tabButtons = tabsElement.querySelectorAll('[data-tab-id]');

    const tabElements = Array.from(tabButtons).map((btn) => {
        const tabId = btn.dataset.tabId;
        return {
            id: tabId,
            triggerEl: btn,
            targetEl: document.getElementById(tabId),
        };
    });

    const options = {
        defaultTabId: tabElements[0]?.id || null,
        activeClasses:
            `tab-active tab-active-${tabsElement.dataset.class}`,
        inactiveClasses:
            'tab-not-active',
    };

    const instanceOptions = {
        id: 'tabs-plantas',
        override: true,
    };

    const tabs = new Tabs(tabsElement, tabElements, options, instanceOptions);

});
